/**
 * Glasgow Coma Scale - Open Eyes enum
 */
export enum OpenEyes {
    SPONTANEOUSLY = 4,
    TO_SPEECH = 3,
    TO_PAIN = 2,
    NO_RESPONSE = 1,
}
